import React from 'react';
import PropTypes from 'prop-types';

import RequiredIcon from '@decisiv/ui-components/lib/atoms/RequiredIcon';
import { H3, P } from '@decisiv/ui-components/lib/components/Typography';

import { REQUIRED_FIELDS } from './copy';
import { RequiredMarker, StepHeading } from './styles';

/**
 * The heading every form step in the wizard opens with: a title and one line of
 * guidance, with the "Required Fields" key opposite it.
 *
 * The Wizard component can render a step title of its own (`step.title`), but it
 * has no room for the subtitle or the key, so every step passes
 * `hideBodyTitle` and renders this instead.
 */
function StepHeader({ showRequiredKey, subtitle, title }) {
  return (
    <StepHeading>
      <div>
        <H3 style={{ margin: 0 }}>{title}</H3>
        <P shade={1} style={{ margin: 0 }}>
          {subtitle}
        </P>
      </div>
      {showRequiredKey && (
        <RequiredMarker>
          <RequiredIcon />
          <P shade={1} size="small" style={{ margin: 0 }}>
            {REQUIRED_FIELDS}
          </P>
        </RequiredMarker>
      )}
    </StepHeading>
  );
}

StepHeader.propTypes = {
  showRequiredKey: PropTypes.bool,
  subtitle: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

StepHeader.defaultProps = {
  showRequiredKey: false,
};

export default StepHeader;
